const chevron = "_35sc1brmvfx";
const container = "_35scqqco8l";

export { chevron, container };
import "./container.print.style.linaria.module.css";
//# sourceMappingURL=container.print.style.js.map
